import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

import Heading from 'components/Luxkit/Typography/Heading'

const PrintOnlyHeading = styled(Heading)`
  @media not print {
    display: none !important;
  }
`

const NoPrintHeading = styled(Heading)`
  @media print {
    display: none !important;
  }
`

type Props = React.ComponentProps<typeof Heading>

/** A heading that doesn't apply `lineClamp` in print view */
function HeadingFullPrint({
  children,
  lineClamp,
  ...props
}: PropsWithChildren<Props>) {
  if (typeof lineClamp !== 'number') {
    return (
      <Heading {...props} lineClamp={lineClamp}>
        {children}
      </Heading>
    )
  }

  return (
    <>
      <NoPrintHeading {...props} lineClamp={lineClamp}>
        {children}
      </NoPrintHeading>
      <PrintOnlyHeading {...props}>{children}</PrintOnlyHeading>
    </>
  )
}

export default HeadingFullPrint
